import { render, staticRenderFns } from "./ContractsPage.vue?vue&type=template&id=48fdedb6&"
import script from "./ContractsPage.vue?vue&type=script&lang=js&"
export * from "./ContractsPage.vue?vue&type=script&lang=js&"
import style0 from "./ContractsPage.vue?vue&type=style&index=0&id=48fdedb6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports